<template>
    <div class="specialPunchMgt">
        <div class="filters">
            <div class="add flexstart"></div>
            <div class="search">
                <el-date-picker v-model="timeSlot" type="daterange" value-format="yyyy-MM-dd" range-separator="-"
                                class="condition" :picker-options="pickerDateFront"
                                start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
                <el-input v-model="param.customername" placeholder="请输入用户名称" class="condition" clearable></el-input>
                <el-button type="primary" plain @click="handleQuery">搜索</el-button>
            </div>
        </div>
        <div class="result-list btn-operate-list">
            <el-table :data="tableData" style="width: 100%" ref="multipleTable">
                <el-table-column prop="subject" label="用户名称" min-width="120px" class-name="title">
                    <template slot-scope="scope">
                        <div class="imageText">
                            <img class="img" v-lazy="scope.row.headimageurl" :alt="scope.row.customername"
                                 preview="bbOrderList">
                            <span class="text-ellipse">{{scope.row.customername}}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="punchdate" label="打卡日期" class-name="tc" label-class-name="tc"></el-table-column>
                <el-table-column prop="punchtime" label="打卡时间" class-name="tc" label-class-name="tc"></el-table-column>
                <el-table-column prop="joinexamcount" label="参与试卷数" class-name="tc" label-class-name="tc"></el-table-column>
                <el-table-column prop="finishexamcount" label="完成试卷数" class-name="tc" label-class-name="tc"></el-table-column>
            </el-table>
            <el-pagination background @current-change="_getList" :current-page.sync="page.page" :page-size="page.pageSize"
                           :pager-count="11" layout="prev, pager, next" :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {getQuestionbankuserpunchinfo} from 'api/questionApi'

export default {
    name: 'specialPunchMgt',
    data() {
        return {
            tableData: [],
            page: {
                page: 1,
                pageSize: 10,
                pageCount: 0
            },
            total: 0,
            timeSlot: null,
            param: {
                begintime: '',
                endtime: '',
                customername: '',
                customerid: '',
                examcode: this.$route.query.examcode ? this.$route.query.examcode : ''
            },
            pickerDateFront: {
                disabledDate(time) {
                    return time.getTime() > Date.now()
                },
                onPick({ maxDate, minDate }) {
                    if (maxDate) {
                        if (maxDate - minDate > 30 * 24 * 60 * 60 * 1000) {
                            this.$message.error('时长不能超过30天，请重新选择')
                        }
                    }
                }
            },
            init: false
        }
    },
    mounted() {
    },
    methods: {
        initData() {
            if (!this.init) this._getList()
        },
        handleQuery() {
            if (this.timeSlot) {
                let beginDate = new Date(this.timeSlot[0])
                let endDate = new Date(this.timeSlot[1])
                if (endDate- beginDate > 30 * 24 * 60 * 60 * 1000) {
                    this.$message.error('时长不能超过30天，请重新选择')
                    return false
                }
                this.param.begintime = this.timeSlot[0]
                this.param.endtime = this.timeSlot[1]
            } else {
                this.param.begintime = ''
                this.param.endtime = ''
            }
            this.page.page = 1
            this._getList()
        },
        _getList() {
            this.setLoading(true)
            getQuestionbankuserpunchinfo({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.tableData = data.data.content
                    this.total = data.data.pageinfo.rowCount
                    this.init = true
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions(['setLoading'])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .specialPunchMgt {
    }
</style>
